import { createAsyncThunk } from "@reduxjs/toolkit";
import { addCoreDocumentMetadataAPI, addDocumentDetails, 
  addDocumentMetadataAPI, addTagAPI, getAllCategoryAPI, getAllTagsAPI, 
  getDocumentAPI, getSubCategoryAPI, getTableColumnNames, removeDocuments, 
  uploadImages, updateDocumentDetails, updateDocumentJsonURL, 
  retryDocumentAPI, reviewedDocument } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


import { APIClient } from "../../helpers/api_helper";
import * as url from "../../helpers/url_helper";
import { updateFileProcessingStatus, setUploadError } from "./reducer";
import { getAuthUser } from "../../helpers/utils";
const api = new APIClient();
const { user } = getAuthUser();


// Fetch Document Table Column Names
export const fetchDocumentTableColumnNames = createAsyncThunk(
  "aiDoc/fetchTableColumnNames",
  async (document, thunkAPI) => {
    try {
      const response = await getTableColumnNames(document); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

export const uploadDocumentFile = createAsyncThunk(
  "AIDoc/uploadDocumentFile",
  // 1. Accept 'isMultiUpload' in the payload. Default it to false for backward compatibility.
  async ({ formData, onProgress, isMultiUpload = false }, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetch(url.UPLOAD_DOC, {
        method: "POST",
        body: formData,
      });

      if (!response.body) {
        throw new Error("No response body for stream");
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";
      dispatch(setUploadProgress(0));

      const progressMap = {
        init: 0,
        file_uploaded: 25,
        file_ocr_done: 50,
        other_data: 75,
        file_processed: 100,
        // all_done: 100,
      };

      return new Promise(async (resolve, reject) => {
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            resolve(); // Stream ended
            break;
          }

          buffer += decoder.decode(value, { stream: true });
          const events = buffer.split("\n\n");
          buffer = events.pop();

          for (const eventBlock of events) {
            if (!eventBlock) continue;
            
            const lines = eventBlock.split("\n");
            let eventName = "";
            let eventData = "";

            for (const line of lines) {
              if (line.startsWith("event:")) eventName = line.slice(6).trim();
              else if (line.startsWith("data:")) eventData += line.slice(5).trim();
            }

            try {
              if (!eventName || !eventData) continue;
              const parsedData = JSON.parse(eventData);

              // 2. This is the core logic change
              if (eventName === "duplicate") {
                // ALWAYS forward the event to the UI for immediate feedback
                onProgress({ event: eventName, data: parsedData });

                // if (isMultiUpload) {
                //   // For multi-upload, this is NOT a fatal error.
                //   // We just continue listening for the next file's events.
                //   continue; 
                // } else {
                //   // For single-upload, this IS a fatal error.
                //   // Reject the promise to trigger the component's global error state.
                //   reject(new Error(parsedData.message || 'duplicateFile'));
                //   return; // Stop the entire process
                // }
              }
              
              const percent = progressMap[eventName] ?? 0;
              if (percent > 0) dispatch(setUploadProgress(percent));
              
              onProgress({ event: eventName, data: parsedData });

              if (eventName === "error") {
                // const parsedData = JSON.parse(eventData);
                dispatch(updateFileProcessingStatus({ ID: parsedData.DBID, JsonURL: null, IsProcessed: null, ModifiedByID: user.ID}))
                toast.error(parsedData.message || t("Upload failed"));
                // dispatch(setUploadError(parsedData.message || "Upload failed"));
                reject(new Error(parsedData.message || "Upload failed"));
                return;
              }

              if (eventName === "file_processed") {
                const data = typeof parsedData === "string" ? JSON.parse(parsedData) : parsedData;
                const payload = {
                  ID: data.DBID,
                  JsonURL: parsedData.url,
                  IsProcessed: true,
                  ModifiedByID: user.ID
                };
                dispatch(updateFileProcessingStatus(payload));
              }

              if (eventName === "all_done") {
                resolve(parsedData);
              }
            } catch (e) {
              console.warn("Invalid SSE event data:", eventData, e);
            }
          }
        }
      });
    } catch (err) {
      console.error("Upload Stream Failed:", err);
      return rejectWithValue(err.message || "errorUploadingDocument");
    }
  }
);

export const retryDocumentFile = createAsyncThunk(
  "AIDoc/retryDocumentFile",
  // 1. Accept 'isMultiUpload' in the payload. Default it to false for backward compatibility.
  async ({ formData, onProgress, isMultiUpload = false }, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetch(url.RETRY_DOC, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: formData,
      });

      if (!response.body) {
        throw new Error("No response body for stream");
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";
      dispatch(setUploadProgress(0));

      const progressMap = {
        init: 0,
        creating: 25,
        new_json: 50,
        other_data: 75,
        file_processed: 100,
      };

      return new Promise(async (resolve, reject) => {
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            resolve(); // Stream ended
            break;
          }

          buffer += decoder.decode(value, { stream: true });
          const events = buffer.split("\n\n");
          buffer = events.pop();

          for (const eventBlock of events) {
            if (!eventBlock) continue;
            
            const lines = eventBlock.split("\n");
            let eventName = "";
            let eventData = "";

            for (const line of lines) {
              if (line.startsWith("event:")) eventName = line.slice(6).trim();
              else if (line.startsWith("data:")) eventData += line.slice(5).trim();
            }

            try {
              if (!eventName || !eventData) continue;
              const parsedData = JSON.parse(eventData);

              // 2. This is the core logic change
              if (eventName === "duplicate") {
                // ALWAYS forward the event to the UI for immediate feedback
                onProgress({ event: eventName, data: parsedData });

                // if (isMultiUpload) {
                //   // For multi-upload, this is NOT a fatal error.
                //   // We just continue listening for the next file's events.
                //   continue; 
                // } else {
                //   // For single-upload, this IS a fatal error.
                //   // Reject the promise to trigger the component's global error state.
                //   reject(new Error(parsedData.message || 'duplicateFile'));
                //   return; // Stop the entire process
                // }
              }
              
              const percent = progressMap[eventName] ?? 0;
              if (percent > 0) dispatch(setUploadProgress(percent));
              
              onProgress({ event: eventName, data: parsedData });

              if (eventName === "error") {
                // const parsedData = JSON.parse(eventData);
                dispatch(updateFileProcessingStatus({ ID: parsedData.DBID, JsonURL: null, IsProcessed: null, ModifiedByID: user.ID}))
                toast.error(parsedData.message || t("Upload failed"));
                // dispatch(setUploadError(parsedData.message || "Upload failed"));
                reject(new Error(parsedData.message || "Upload failed"));
                return;
              }

              if (eventName === "file_processed") {
                const data = typeof parsedData === "string" ? JSON.parse(parsedData) : parsedData;
                const payload = {
                  ID: data.DBID,
                  JsonURL: parsedData.url,
                  IsProcessed: true,
                  ModifiedByID: user.ID
                };
                dispatch(updateFileProcessingStatus(payload));
              }

              if (eventName === "all_done") {
                resolve(parsedData);
              }
            } catch (e) {
              console.warn("Invalid SSE event data:", eventData, e);
            }
          }
        }
      });
    } catch (err) {
      console.error("Upload Stream Failed:", err);
      return rejectWithValue(err.message || "errorUploadingDocument");
    }
  }
);

// Add this action to your slice for progress
export const setUploadProgress = (percent) => ({
  type: "AIDoc/setUploadProgress",
  payload: percent,
});

export const uploadImageFile = createAsyncThunk(
  "aiDoc/uploadImageFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadImages(formData);
      return response.data; 
    } catch (error) {
      return rejectWithValue(error || error.message || "Error uploading PDF Thumbnail");
    }
  }
);

// Thunk to fetch all categories
export const fetchCategories = createAsyncThunk(
  "aiDoc/fetchCategories",
  async (logs, thunkAPI) => {
    try {
      const response = await getAllCategoryAPI(logs); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Thunk to fetch all tags
export const fetchAllTags = createAsyncThunk(
  "aiDoc/fetchAllTags",
  async (logs, thunkAPI) => {
    try {
      const response = await getAllTagsAPI(logs); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Thunk to add a new tag
export const addNewTag = createAsyncThunk(
  "aiDoc/addNewTag",
  async (tagData, { rejectWithValue }) => {
    try {      
      const response = await addTagAPI(tagData);
      if (response.data && response.data.TagName) {
        toast.success(t(`Tag created successfully`));
      }
      return response.data; 
    } catch (error) {
      return rejectWithValue(error || error.message || "Error adding new tag");
    }
  }
);

// Thunk to fetch all tags
export const fetchAllDocument = createAsyncThunk(
  "aiDoc/fetchAllDocument",
  async (data, thunkAPI) => {
    try {
      const response = await getDocumentAPI(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Thunk to save document metadata
export const saveDocumentMetadata = createAsyncThunk(
  "aiDoc/saveDocumentMetadata",
  async (metadata, { rejectWithValue }) => {
    try {
      const response = await addDocumentMetadataAPI(metadata);
      toast.success(
        t(
          metadata.DocumentTypeID === 4
            ? "DocumentSavedSuccessfully"
            : metadata.DocumentTypeID === 5
            ? "BookSavedSuccessfully"
            : metadata.DocumentTypeID === 6
            ? "ArticleSavedSuccessfully"
            : "DocumentSavedSuccessfully"
        )
      ); 
        return response.data; 
    } catch (error) {
      return rejectWithValue(error || error.message || t("Error saving document metadata"));
    }
  }
);

// Thunk to save document metadata
export const saveCoreDocumentMetadata = createAsyncThunk(
  "aiDoc/saveCoreDocumentMetadata",
  async (metadata, { rejectWithValue }) => {
    try {
      const response = await addCoreDocumentMetadataAPI(metadata);
      toast.success(t("Document saved successfully"));
      return response.data; 
    } catch (error) {
      return rejectWithValue(error || error.message || t("Error saving document metadata"));
    }
  }
);

// Thunk to update document
export const updateDocument = createAsyncThunk(
  "aiDoc/updateDocument",
  async (document, { rejectWithValue }) => {
    try {
      const response = await updateDocumentDetails(document);
      toast.success(t("DocumentDetailsSavedMessage"));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || error.message || t("Error saving document Details"));
    }
  }
);

// Thunk to update document json url
export const updateDocumentJson = createAsyncThunk(
  "aiDoc/updateDocumentJson",
  async (document, { rejectWithValue }) => {
    try {
      const response = await updateDocumentJsonURL(document);
      toast.success(t("DocumentDetailsSavedMessage"));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || error.message || t("Error saving document Details"));
    }
  }
);

// Thunk to save document Details
export const saveDocumentDetails = createAsyncThunk(
  "aiDoc/saveDocumentDetails",
  async (document, { rejectWithValue }) => {
    try {
      const response = await addDocumentDetails(document);
      toast.success(t("DocumentDetailsSavedMessage"));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || error.message || t("Error saving document Details"));
    }
  }
);

// Reviewed Document
export const reviewedDocumentJson = createAsyncThunk("aiDoc/reviewedDocument", async (document, thunkAPI) => {
  try {
    const response = await reviewedDocument(document);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Retry Document
export const retryDocument = createAsyncThunk("aiDoc/retryDocument", async (document, thunkAPI) => {
  try {
    const response = await retryDocumentAPI(document);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Merge Document Json
export const mergeDocumentJson = createAsyncThunk("aiDoc/MergeJson",   async ({ formData, onProgress = () => {} }, { rejectWithValue, dispatch }) => {
  try {
    const response = await fetch(url.MERGE_DOCUMENT_JSON, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    });

    if (!response.body) {
      throw new Error("No response body for stream");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";

    return new Promise(async (resolve, reject) => {
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          resolve(); // Stream ended
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const events = buffer.split("\n\n");
        buffer = events.pop();

        for (const eventBlock of events) {
          if (!eventBlock) continue;
          
          const lines = eventBlock.split("\n");
          let eventName = "";
          let eventData = "";

          for (const line of lines) {
            if (line.startsWith("event:")) eventName = line.slice(6).trim();
            else if (line.startsWith("data:")) eventData += line.slice(5).trim();
          }

          try {
            if (!eventName || !eventData) continue;
            const parsedData = JSON.parse(eventData);
            
            // onProgress({ event: eventName, data: parsedData });

            if (eventName === "error") {
              toast.error(parsedData.message || t("Merged failed"));
              dispatch(updateFileProcessingStatus({ ID: formData.DocID, JsonURL: null, IsProcessed: false, ModifiedByID: user.ID }));
              reject(new Error(parsedData.message || "Merged failed"));
              return;
            }

            if (eventName === "JSONURLs") {
              const data = typeof parsedData === "string" ? JSON.parse(parsedData) : parsedData;
              const payload = {
                ID: data.DocID,
                JsonURL: parsedData.mergedJsonUrl,
                IsProcessed: true,
                ModifiedByID: user.ID
              };
              dispatch(updateFileProcessingStatus(payload));
            }

            if (eventName === "all_done") {
              resolve(parsedData);
            }
          } catch (e) {
            console.warn("Invalid SSE event data:", eventData, e);
          }
        }
      }
    });
  } catch (err) {
    console.error("Upload Stream Failed:", err);
    return rejectWithValue(err.message || "errorUploadingDocument");
  }
});

// Delete Document
export const deleteDocuments = createAsyncThunk("aiDoc/deleteDocuments", async (document, thunkAPI) => {
    try {
        const response = await removeDocuments(document);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
});

//Get Sub Category
export const fetchSubCategories = createAsyncThunk(
  "categories/fetchSubCategories",
  async (logs, thunkAPI) => {
    try {
      const response = await getSubCategoryAPI(logs); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);